
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "OuDetail"
})
export default class extends Vue {
  @Prop() item!: any;
  @Prop({ required: false, default: "机构详情" }) formTitle!: string;
  @Prop({ required: false, default: "rtl" }) direction!: string;

  show = false;

  private handleClose() {
    this.show = false;
  }
}
